export const UnitTypeId = {
	document: 1,
	video: 2,
	test: 3,
	webcontent: 4,
	webinar: 5,
	assignment: 6,
} as const;
